<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="3" md="3" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        v-model="selectedLcId"
                        :items="lcList"
                        :item-title="item => `${item.lc_no} - ${item.code || ''}`"
                        item-value="id"
                        label="Filter by LC"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        density="compact"
                        clearable
                        hide-details
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                LC Costing Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goToCreate"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Create Costing
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="filteredCostingList"
                  :search="search"
                  :loading="loading"
                  item-value="id"
                  class="elevation-1"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.lc_id="{ item }">
                    {{ item.lc_master?.lc_no || item.lc_id }}
                  </template>

                  <template v-slot:item.total_landed_cost="{ item }">
                    {{ formatCurrency(item.total_landed_cost) }}
                  </template>

                  <template v-slot:item.total_accepted_qty="{ item }">
                    {{ formatNumber(item.total_accepted_qty) }}
                  </template>

                  <template v-slot:item.landed_cost_per_unit="{ item }">
                    {{ formatCurrency(item.landed_cost_per_unit) }}
                  </template>

                  <template #item.conversion_rate="{ item }">
                    {{ Number(item.conversion_rate).toFixed(2) }}
                  </template>

                  <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                      v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                      color="yellow-darken-3"
                      size="small"
                    >
                      Wating for {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                      color="green"
                      size="small"
                    >
                      Approved By {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                      color="red"
                      size="small"
                    >
                      Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                    </v-chip>
                    <v-chip
                      v-else
                      color="green"
                      size="small"
                    >
                      {{ item.approval_status }}
                    </v-chip>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="item.status === 1 ? 'success' : 'grey'"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.status === 1 ? 'Posted' : 'Draft' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="info"
                      @click="viewCosting(item.id)"
                    ></v-btn>
                    <v-btn
                      icon="mdi-pencil"
                      size="small"
                      variant="text"
                      @click="editCosting(item.id)"
                      v-if="canEdit(item)"
                    ></v-btn>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import { useForm, useField } from "vee-validate";

export default {
  name: "LcImportLcCostingRecord",
  setup() {
    const store = useStore();
    const router = useRouter();

    const panel = ref([0]);
    const panel1 = ref([0]);
    const loading = ref(false);
    const search = ref("");
    const selectedLcId = ref(null);

    const { handleSubmit } = useForm();
    const from_date = useField("from_date");
    const to_date = useField("to_date");

    const headers = [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "Code", key: "code", align: "left", sortable: true },
      { title: "LC No", key: "lc_id", align: "left", sortable: true },
      { title: "Shipment No", key: "shipment.code", align: "left", sortable: true },
      { title: "Date", key: "date", align: "left", sortable: true },
      { title: "Currency", key: "currency.code", align: "left", sortable: true },
      { title: "Coversion Rate (TK)", key: "conversion_rate", align: "left", sortable: true },
      { title: "Approval Status", key: "approval_status_display", align: "center", sortable: true },
      { title: "Status", key: "status", align: "center", sortable: true },
      { title: "Actions", key: "actions", sortable: false, align: "center", width: "10%" },
    ];

    const getLcImportLcCostingList = computed(() => {
      return store.getters["lcImportLcCosting/getLcImportLcCostingList"] || [];
    });

    const lcList = computed(() => {
      return store.getters.getLcImportLcMasterList || [];
    });

    const filteredCostingList = computed(() => {
      let filtered = [...getLcImportLcCostingList.value];

      if (selectedLcId.value) {
        //filtered = filtered.filter(item => item.lc_id === selectedLcId.value);
      }

      // Date range filtering can be added here if needed
      // if (from_date.value.value && to_date.value.value) {
      //   filtered = filtered.filter(item => {
      //     const itemDate = new Date(item.created_at);
      //     return itemDate >= new Date(from_date.value.value) && itemDate <= new Date(to_date.value.value);
      //   });
      // }
      return filtered;
    });

    const formatNumber = (num) => {
      if (!num && num !== 0) return "0.00";
      return Number(num).toFixed(2);
    };

    const formatCurrency = (amount) => {
      if (!amount && amount !== 0) return "0.00";
      return Number(amount).toFixed(2);
    };

    const loadCostingList = async () => {
      loading.value = true;
      try {
        await store.dispatch("lcImportLcCosting/getLcImportLcCostingList");
      } catch (error) {
        toast.error("Failed to load costing records");
      } finally {
        loading.value = false;
      }
    };

    const submit = handleSubmit(async (values) => {
      await loadCostingList();
    });

    const goToCreate = () => {
      router.push({ name: "lc-import-lc-costing-create" });
    };

    const viewCosting = (id) => {
      router.push({ name: "lc-import-lc-costing-view", params: { id } });
    };

    const editCosting = (id) => {
      router.push({ name: "lc-import-lc-costing-edit", params: { id } });
    };

    const canEdit = (item) => {
      return item.status === 0 || item.approval_status != "Approved";
    };

    const exportToCSV = () => {
      toast.info("CSV export feature coming soon");
    };

    const exportToExcel = () => {
      toast.info("Excel export feature coming soon");
    };

    const exportToPDF = () => {
      toast.info("PDF export feature coming soon");
    };

    onMounted(async () => {
        await store.dispatch("getLcImportLcMasterList");
    });

    return {
      panel,
      panel1,
      loading,
      search,
      selectedLcId,
      from_date,
      to_date,
      headers,
      getLcImportLcCostingList,
      lcList,
      filteredCostingList,
      formatNumber,
      formatCurrency,
      loadCostingList,
      submit,
      goToCreate,
      viewCosting,
      editCosting,
      exportToCSV,
      exportToExcel,
      exportToPDF,
      canEdit,
    };
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>
